import { render, staticRenderFns } from "./DialogDetil.vue?vue&type=template&id=915a9112&"
import script from "./DialogDetil.vue?vue&type=script&lang=js&"
export * from "./DialogDetil.vue?vue&type=script&lang=js&"
import style0 from "./DialogDetil.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports